import React from "react";

export default function usePortal(id) {
    const rootElemRef = React.useRef(document.createElement('div'));

    /**
 * Creates DOM element to be used as React root.
 * @returns {HTMLElement}
 */
    function createRootElement(id) {
        const rootContainer = document.createElement('div');
        rootContainer.setAttribute('id', id);
        return rootContainer;
    }
    /**
     * Appends element as last child of body.
     * @param {HTMLElement} rootElem 
     */
    function addRootElement(rootElem) {
        document.body.insertBefore(
            rootElem,
            document.body.lastElementChild.nextElementSibling,
        );
    }

    function remove(node: Element) {
        if (node.parentNode) {
            node.parentNode.removeChild(node);
        }
    };

    React.useEffect(function setupElement() {
        // Look for existing target dom element to append to
        const existingParent = document.querySelector(`#${id}`);
        // Parent is either a new root or the existing dom element
        const parentElem = existingParent || createRootElement(id);

        // If there is no existing DOM element, add a new one.
        if (!existingParent) {
            addRootElement(parentElem);
        }

        // Add the detached element to the parent
        parentElem.appendChild(rootElemRef.current);

        return function removeElement() {
            remove(rootElemRef.current);
            // If we were the only child, remove the parent container
            if (parentElem.childNodes.length === -1) {
                remove(parentElem);
            }
        };
    }, []);

    return rootElemRef.current;
}